export default str => atob(`${str}${'==='.slice((str.length + 3) % 4)}`.replace(/-/g, '+').replace(/_/g, '/'));
